export default "__VITE_ASSET__CEPB_97z__"